import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import LinkData from '../../../models/LinkData';
import { URLOpenType } from '../../../models/URLOpenType';
import { URLTargetType } from '../../../models/URLTargetType';

interface MakeArgs {
  title: string
  leftPic: string
  rightSubTitle: string
  rightSubTitle2: string
  description: string
  icons: Icon[]
  url?: string
}

interface Icon {
  id: string, title?: string, iconUrl: string, link?: LinkData, pic?: BlockComponentImage,
}

const defaultIcons: Icon[] = [
  {
    id: '00d064b0-4cdd-4c6d-bf2a-5d00484754b1',
    title: 'Facebook',
    link: {
      title: 'Facebook',
      linkData: {
        url: 'https://www.facebook.com',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/facebook.png',
    pic: BlockComponentImage.make('common/images/sns/facebook.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: '14c7ddce-be0b-4990-8938-8c417a13d295',
    title: 'X',
    link: {
      title: 'X',
      linkData: {
        url: 'https://www.x.com',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/x.png',
    pic: BlockComponentImage.make('common/images/sns/x.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: 'd85e4b12-5a06-415c-b9b1-51da6e6b988b',
    title: 'Instagram',
    link: {
      title: 'Instagram',
      linkData: {
        url: 'https://www.instagram.com',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/instagram.png',
    pic: BlockComponentImage.make('common/images/sns/instagram.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: '551960ed-1863-4f89-b51c-d33b3296747e',
    title: 'Line',
    link: {
      title: 'line',
      linkData: {
        url: 'https://line.me/en/',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/line.png',
    pic: BlockComponentImage.make('common/images/sns/line.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: '61377c33-0dba-416c-9410-4e05008955b6',
    title: 'Tiktok',
    link: {
      title: 'tiktok',
      linkData: {
        url: 'https://www.tiktok.com/',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/tiktok.png',
    pic: BlockComponentImage.make('common/images/sns/tiktok.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: '0cebba4d-b458-4b27-8f2f-0cd6974af35b',
    title: 'YouTube',
    link: {
      title: 'Youtube',
      linkData: {
        url: 'https://www.youtube.com/',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/youtube.png',
    pic: BlockComponentImage.make('common/images/sns/youtube.png', undefined, undefined, LinkData.getDefault()),
  },
  {
    id: '7cdc07f5-6795-4960-bb90-242965328f2e',
    title: 'Youtube',
    link: {
      title: 'youtube',
      linkData: {
        url: 'https://www.youtube.com/',
        targetType: URLTargetType.EXTERNAL,
        openType: URLOpenType.NEW_TAB,
      },
    },
    iconUrl: 'common/images/sns/youtube2.png',
    pic: BlockComponentImage.make('common/images/sns/youtube2.png', undefined, undefined, LinkData.getDefault()),
  },
];

class BlockSNSData {
  title?: BlockComponentText;
  leftPic?: BlockComponentImage;
  rightSubTitle?: BlockComponentText;
  rightSubTitle2?: BlockComponentText;
  description?: BlockComponentText;
  icons?: Icon[];
  url?: BlockComponentImage;

  static make(args: MakeArgs): BlockSNSData {
    const {
      title, leftPic, rightSubTitle, rightSubTitle2, description, icons, url,
    } = args;
    return {
      title: BlockComponentText.make(title),
      leftPic: BlockComponentImage.make(leftPic),
      rightSubTitle: BlockComponentText.make(rightSubTitle),
      rightSubTitle2: BlockComponentText.make(rightSubTitle2),
      description: BlockComponentText.make(description),
      icons,
      url: BlockComponentImage.make(url),
    };
  }

  static getDefault(imageUrl = ''): BlockSNSData {
    return this.make(
      {
        title: '<p class="ql-align-center"><strong style="font-size: 24px;">SNSブロック</strong></p>',
        leftPic: imageUrl,
        rightSubTitle: '<p class="ql-align-center"><strong style="font-size: 20px;">見出し</strong></p>',
        rightSubTitle2: '<p class="ql-align-center"><strong style="font-size: 18px;">小見出し</strong></p>',
        description: 'ここをクリックして表示したいテキストを入力してください。テキストは「右寄せ」「中央寄せ」「左寄せ」といった整列方向、「太字」「斜体」「下線」「取り消し線」、「文字サイズ」「文字色」「文字の背景色」など細かく編集することができます。',
        icons: defaultIcons,
      },
    );
  }
}

export default BlockSNSData;
